import { Table, Typography } from "antd";
import React, { useEffect, useState } from "react";

const TeamSummaryStats = (props) => {
  const { team, title } = props;
  const [result, setResult] = useState();

  useEffect(() => {
    setResult(team.statistics);
    // eslint-disable-next-line
  }, [team]);

  const columns = [
    {
      render: (x) => <Typography.Text className="font-weight-bold">{x.title}</Typography.Text>,
    },
    {
      render: (x) => x.item(),
    },
  ];

  const listItems = [
    {
      title: "Results:",
      item: () => (
        <>
          Played: {result.games}&nbsp;Wins: {result.wins}&nbsp;Losses: {result.losses}
        </>
      ),
    },
    {
      title: "Fast break points:",
      item: () => result.pointsFastBreak,
    },
    {
      title: "Points in the paint:",
      item: () => result.pointsInThePaint,
    },
    {
      title: "Second chance points:",
      item: () => result.pointsSecondChance,
    },
    {
      title: "Bench points:",
      item: () => result.pointsFromBench,
    },
  ];

  return (
    <React.Fragment>
      {result && (
        <>
          <Typography.Title level={4}>{title} - Team Summary </Typography.Title>
          <div style={{ display: "inline-block" }}>
            <Table
              showHeader={false}
              dataSource={listItems}
              rowKey={"title"}
              columns={columns}
              size="small"
              pagination={false}
            />
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default TeamSummaryStats;
